export const VALIDATION_ERROR_TYPES = {
  MISSING_TAG_DIMENSION: "MISSING_TAG_DIMENSION",
} as const;
